export const emoji = {
    handRaised: '\u{1F64B}\u{200D}\u{2642}\u{FE0F}',
    foxMuzzle: '🦊',
};
